import { Trans, useTranslation } from "react-i18next";

import { getSegmentChangeVariant } from "../changeVariant";

import {
  HistoryEntryCard,
  type EntityHistoryEntry,
} from "@/components/ui/v2/history";

interface SegmentCampaignChanges {
  campaignName?: string | null;
}

export function SegmentCampaignHistoryItem({
  entry,
}: {
  entry: EntityHistoryEntry;
}) {
  const { t } = useTranslation();
  const changes = entry.changes as SegmentCampaignChanges | undefined;
  const isRemoval = entry.changeType === "SegmentRemovedFromCampaign";
  const actor = t("history.actor.system");
  return (
    <HistoryEntryCard
      occurredAt={entry.occurredAt}
      description={
        <Trans
          i18nKey={
            isRemoval
              ? "history.line1.segmentRemovedFromCampaign"
              : "history.line1.segmentAddedToCampaign"
          }
          values={{ actor, name: changes?.campaignName ?? "—" }}
          components={{ b: <strong className="font-semibold" /> }}
        />
      }
      variant={getSegmentChangeVariant(entry.changeType)}
    />
  );
}
